import { FunctionComponent, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useGetLiveGamesInCase } from '~components/home/hooks';
import _ from 'lodash';

import { Drop } from './Drop';

export const LiveDrops: FunctionComponent = () => {
  const { t } = useTranslation();
  const getLiveGamesInCase = useGetLiveGamesInCase();

  const liveDrops = useMemo(() => {
    return (
      <div className="top-drop-wrap">
        <div className="drop-btns">
          <a className="drop-best active" href="#">
            <div className="drop-best-wrap">
              <div className="badge">Best drop</div>
              <span className="icon material-icons">star</span>
            </div>
          </a>
        </div>
        <div className="top-drop">
          {_.map(getLiveGamesInCase, getGame => (
            <Drop getGame={getGame} key={getGame.id} />
          ))}
        </div>
      </div>
    );
  }, [getLiveGamesInCase]);

  if (_.size(getLiveGamesInCase) === 0) {
    return null;
  }

  return (
    <div className="live-drop-case">
      <div className="top-drop-title">
        <div className="top-drop-title-wrap">{t('The last best drop')}</div>
      </div>
      {liveDrops}
    </div>
  );
};
